export default {
    dbi_twitch_channels: 'Twitch渠道',
    dbi_youtube_channels: 'Youtube渠道',
    dbi_facebook_channels: 'Facebook渠道',
    dbi_Primary_games: '初级游戏',
    dbi_Primary_hours_watched: '观看时长',
    dbi_Primary_peak: '高峰同时收视率',
    dbi_Primary_avg: '平均同时收视率',
    dbi_Primary_airtime: '播放时间',
    dbi_Primary_Key_metrics: '关键指标',
    dbi_Primary_stream_metrics: '直播指标',
    dbi_Primary_channel: '初级渠道',
    dbi_Primary_kol: '关键意见领袖',
    dbi_streaming_twitch: 'Twitch',
    dbi_streaming_youtube: 'YouTube',
    dbi_streaming_facebook_gaming: 'Facebook游戏',
    dbi_streaming_language_country: '语言/国家',
    dbi_streaming_channel_url: '渠道网址',
    dbi_Primary_disabled_messages1: '这个过滤器只适用于Twitch平台',
    dbi_Primary_disabled_messages2: '这个过滤器只适用于YouTube平台',
}